// src/pages/markets/board/state/profileOrder.ts
//
// Sequence for the profile row. Pure: no React, no Firestore.

import type { BoardProfile } from './profileTypes';

// Listed ids first, in their sequence; anything the list has never seen is
// appended oldest-first so a profile made elsewhere cannot disappear.
export function orderByIds(
    profiles: BoardProfile[],
    orderIds: readonly string[]
): BoardProfile[] {
    const byId = new Map(profiles.map(p => [p.id, p]));
    const out: BoardProfile[] = [];
    const placed = new Set<string>();

    for (const id of orderIds) {
        const hit = byId.get(id);
        if (!hit || placed.has(id)) continue;
        out.push(hit);
        placed.add(id);
    }

    const rest = profiles
        .filter(p => !placed.has(p.id))
        .sort((a, b) => (a.created_at ?? '').localeCompare(b.created_at ?? ''));

    return [...out, ...rest];
}

// Missing order sorts last: no shared profile has one until an admin drags, and
// the row still has to be stable before that.
export function orderShared(profiles: BoardProfile[]): BoardProfile[] {
    return [...profiles].sort((a, b) => {
        const ao = a.order ?? Number.POSITIVE_INFINITY;
        const bo = b.order ?? Number.POSITIVE_INFINITY;
        if (ao !== bo) return ao - bo;
        return (a.name ?? '').localeCompare(b.name ?? '');
    });
}
